import React, { Component } from 'react'
import Tile from '../tags/Tile'
import Sidebar from '../tags/Sidebar'
import { getAllTiles, getAllTilesPreview } from '../../services/reservoir'
import {
  createFavouritedTile,
  deleteFavouritedTile,
  getFavouritedTiles,
  getReservoirApiUrl
} from '../../services/vu'
import WeeklyNotifications from '../tags/WeeklyNotifications'
import Loading from '../tags/Loading'
import { getSortedTiles } from '../../helpers/tile'
import { connect } from 'react-redux'
import SurveyTile from '../tags/SurveyTile'
import { getProperty } from '../../helpers/properties';
import CommencementStatus from '../../enums/CommencementStatus'
import { getPreviewModeEnabled } from '../../services/liveview'
import {getConfiguration} from "../../helpers/configuration";

const mapStateToProps = ({
  courses: { selectedCourseCode, data },
  course: { selectedCourse },
  sliders,
  tiles: {
    selectedCategory,
    selectedLocation: { locationName }
  },
  page: { title },
  currentUser
}) => {
  const courseSliders = sliders[selectedCourseCode]

  const { sliderItems = [] } = courseSliders.data.find(slider => {
    return slider.id === courseSliders.defaultSlider
  })

  const selectedSliderItem = sliderItems.find(
    sliderItem => sliderItem.id === courseSliders.selectedSlide
  )

  return {
    courseId: selectedCourseCode,
    admissionCategory: selectedCourse.admissionCategory,
    college: selectedCourse.orgUnit,
    hasBlockStatus: selectedCourse.stdblockstatus === 'Y',
    blockStatus: selectedCourse.stdblockstatus,
    courseAttemptStatus: selectedCourse.courseAttemptStatus,
    selectedSlide: sliders[selectedCourseCode].selectedSlide,
    activeCalendarType: selectedSliderItem.teachingPeriod
      ? selectedSliderItem.teachingPeriod.calendarType
      : false,
    associatedWeek: selectedSliderItem.associatedWeek.id,
    locationName: locationName,
    categoryName: selectedCategory,
    pageTitle: title,
    userRole: currentUser.data['role']
  }
}

class HomeContent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      tiles: {
        data: [],
        included: []
      },
      favouritedTiles: [],
      tileImages: [],
      reservoirApiUrl: '/',
      loadingTiles: true,
      surveyTriggered: false,
      surveyUrl: ''
    }
  }

  componentDidMount() {
    this.loadFavouritedTiles()

    getReservoirApiUrl().then(reservoirApiUrl => {
      this.setState({
        reservoirApiUrl: reservoirApiUrl
      })

      this.loadTiles(this.props)
    })
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.courseId !== this.props.courseId ||
      prevProps.selectedSlide !== this.props.selectedSlide ||
      prevProps.categoryName !== this.props.categoryName ||
      prevProps.locationName !== this.props.locationName
    ) {
      this.loadTiles(this.props)
    }
  }

  loadTiles = props => {
    this.setState({
      tiles: {
        ...this.state.tiles,
        data: []
      },
      loadingTiles: true
    })

    const selectedCategory = props.categoryName
    const selectedLocation = props.locationName

    if (!getPreviewModeEnabled()) {
      getAllTiles(
        props.associatedWeek,
        selectedCategory,
        selectedLocation,
        props.admissionCategory,
        props.college,
        props.hasBlockStatus,
        props.courseAttemptStatus,
        props.activeCalendarType,
        props.userRole
      ).then(tiles => {
        this.setState({
          tiles: tiles,
          loadingTiles: false,
          surveyUrl: this.hasMyVUSurveyTile(tiles)
        })
      })
    } else {
      getAllTilesPreview(
        props.associatedWeek,
        selectedCategory,
        selectedLocation,
        props.admissionCategory,
        props.college,
        props.hasBlockStatus,
        props.courseAttemptStatus,
        props.activeCalendarType,
        props.userRole
      ).then(tiles => {
        this.setState({
          tiles: tiles,
          loadingTiles: false,
          surveyUrl: this.hasMyVUSurveyTile(tiles)
        })
      })
    }
  }

  hasMyVUSurveyTile = (tiles) => {
    let surveyTile = tiles.data.find(tile => tile.attributes.field_link_to_video.uri.indexOf('myvuSurveyTile') > -1);
    return surveyTile ? surveyTile.attributes.field_link_to_video.uri : '';
  }

  loadFavouritedTiles = () => {
    getFavouritedTiles().then(favouritedTiles => {
      this.setState({
        favouritedTiles: favouritedTiles
      })
    })
  }

  handleFavouriteButtonClick = tileId => {
    let tileRequest = createFavouritedTile
    if (this.state.favouritedTiles.includes(tileId)) {
      tileRequest = deleteFavouritedTile
    }

    tileRequest(tileId).then(() => {
      this.loadFavouritedTiles()
    })
  }

  handleTriggerSurvey = (canTriggerSurvey = false) => {
    if (canTriggerSurvey) {
      this.setState({
        surveyTriggered: true
      })
    }

    return false
  }

  getCategory = categoryUuid => {
    const category = this.getTileIncluded().find(tileType => {
      return (
        tileType.type === 'taxonomy_term--tile_type' &&
        tileType.id === categoryUuid
      )
    })

    return category && category.attributes && category.attributes.name
  }

  getImage = imageId => {
    const image = this.getTileIncluded().find(image => image.id === imageId)
    return (
      image &&
      image.attributes &&
      image.attributes.uri.url &&
      `${this.state.reservoirApiUrl}${image.attributes.uri.url}`
    )
  }

  getTileIncluded = () =>
    this.state.tiles.included ? this.state.tiles.included : []

  getTileData = () => this.state.tiles.data  

  render() {
    return (
      <div className="row">
        <div className="col-xs-12 col-md-12 col-lg-5 col-xl-4">
          <Sidebar />
        </div>

        <div className="col-xs-12 col-md-12 col-lg-7 col-xl-8">
          {this.state.loadingTiles ? (
            <section className="tile-container">
              <Loading message="Loading your tiles..." />
            </section>
          ) : (
            <section className="tile-container">
              <WeeklyNotifications />

              <div className="row">
                {this.getTileData().length > 0 ? null : (
                  <div className="col-xs-12">
                    <div className="empty-state-container empty-state-container--default">
                      <h2>No content found</h2>
                      <p>There is currently no content for this period.</p>
                    </div>
                  </div>
                )}

                {this.getTileData().length === 0
                  ? null
                  : getSortedTiles(this.getTileData()).map((tile, index) => {
                      const tileAttributes = tile.attributes
                      const tileRelationships = tile.relationships
                      const categoryUuid =
                        tileRelationships &&
                        tileRelationships.field_tile_type &&
                        tileRelationships.field_tile_type.data &&
                        tileRelationships.field_tile_type.data[0] &&
                        tileRelationships.field_tile_type.data[0].id
                      const category = this.getCategory(categoryUuid)
                      const imageId =
                        tileRelationships &&
                        tileRelationships.field_photo &&
                        tileRelationships.field_photo.data &&
                        tileRelationships.field_photo.data.id
                      const image = this.getImage(imageId)

                      if (tileAttributes.field_link_to_video.uri.indexOf('myvuSurveyTile') > -1) {
                        tileAttributes.field_link_to_video.uri = '#'
                      }

                      if (tileAttributes.field_link_to_video.uri.indexOf('internal') > -1) {
                        const url = tileAttributes.field_link_to_video.uri.split(':')
                        tileAttributes.field_link_to_video.uri = getConfiguration('baseUrl') + url[1]
                      }

                      return (
                        <Tile
                          key={tile.id}
                          position={index}
                          context={this.props.pageTitle}
                          tileId={tile.id}
                          link={
                            tileAttributes.field_link_to_video &&
                            tileAttributes.field_link_to_video.uri
                          }
                          imageUrl={image}
                          video={tileAttributes.field_is_video_}
                          category={category}
                          title={tileAttributes.field_heading}
                          description={tileAttributes.field_description}
                          favourited={this.state.favouritedTiles.includes(tile.id)}
                          onFavourite={tileId => this.handleFavouriteButtonClick(tileId)}
                          tileSize={parseInt(tileAttributes.field_size)}
                          onClickSurvey={() => {
                            const canTriggerSurvey =
                              tileAttributes.field_link_to_video.uri.indexOf(
                                '#'
                              ) > -1
                            this.handleTriggerSurvey(canTriggerSurvey)
                          }}
                        />
                      )
                    })}
              </div>
              <SurveyTile
                loadSurvey={this.state.surveyTriggered}
                surveyUrl={this.state.surveyUrl}
              />
            </section>
          )}
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(HomeContent)
